// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 通联银行卡支付绑定银行卡 POST /payment/allin/bank-card/bind */
export async function paymentAllinBankCardBindUsingPOST(
  body: API.AllinBankCardBindReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAllinBankCardBindResp>('/payment/allin/bank-card/bind', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 通联业务确认验证码 POST /payment/allin/verify-code */
export async function paymentAllinVerifyCodeUsingPOST(
  body: API.AllinVerifyCodeReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/payment/allin/verify-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建主订单 POST /payment/order/main */
export async function paymentOrderMainUsingPOST(
  body: API.CreateMainOrderReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCreateMainOrderResp>('/payment/order/main', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建支付子订单 POST /payment/order/sub */
export async function paymentOrderSubUsingPOST(
  body: API.CreatePaymentSubOrderReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCreatePayableSubOrderResp>('/payment/order/sub', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取支付方式 POST /payment/pay-type */
export async function paymentPayTypeUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.paymentPayTypeUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListPaymentTypeResp>('/payment/pay-type', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建营销订单 POST /payment/promotion */
export async function paymentPromotionUsingPOST(
  body: API.CreatePromotionOrderReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCreatePayableSubOrderResp>('/payment/promotion', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建营销H5订单 POST /payment/promotion/h5 */
export async function paymentPromotionH5UsingPOST(
  body: API.CreatePromotionOrderReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCreatePayableSubOrderResp>('/payment/promotion/h5', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查看转账单列表 GET /payment/transfer-order-list */
export async function paymentTransferOrderListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.paymentTransferOrderListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListTransferOrderResp>('/payment/transfer-order-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
